// extracted by mini-css-extract-plugin
export default {"card":"+-C-A","wrapper":"Q15W1","icon":"_9KjOs","description":"hzJNZ","content":"C1my7","active-card":"fY4D2","active-card-mobile":"B1uai"};